import React from "react";

import { Grid } from "@mui/material";

import { ESupplyChainOverviewTabs, OrdersConfigure } from "../../../../../models/supply.chain.overview.configure";
import { useSupplyChainOverviewContext } from "../../context";
import ConfigWidget from "../ConfigWidget";

const PurchaseOrdersConfig = () => {
  const { config, dashboard, handleWidgetConfigChange } = useSupplyChainOverviewContext();

  const configs: Array<keyof OrdersConfigure> = [
    "pendingPurchaseOrders",
    "shipByDate",
    "poStatuses",
    "lastReceivedOrders",
    "poConfirmedVSPoReceived",
  ];

  return (
    <Grid container spacing={0}>
      {configs.map((label: keyof OrdersConfigure) => (
        <Grid item key={`purchaseOrdersConfig-${label}`} xs={4}>
          <ConfigWidget
            handleChange={(value) => handleWidgetConfigChange(ESupplyChainOverviewTabs.ORDERS, label, value)}
            label={label}
            type={dashboard.orders?.graphs[label].type}
            value={config.orders[label] as boolean}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default PurchaseOrdersConfig;
